module.exports = __webpack_public_path__ + "static/media/bg.b110d78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.png
// module id = 102
// module chunks = 0